import {useEffect, useState} from 'react'

import {debounce} from 'es-toolkit'

import {getBreakpoints} from '../services/breakpoint'

const useBreakpoints = () => {
  const [breakpoints, setBreakpoints] = useState(() => getBreakpoints())

  useEffect(() => {
    const calculateAndSetBreakpoints = () => setBreakpoints(getBreakpoints())

    const onResize = debounce(() => {
      calculateAndSetBreakpoints()
    }, 200)

    global.addEventListener('resize', onResize, false)
    global.addEventListener('orientationchange', onResize, false)

    return () => {
      onResize.cancel()
      global.removeEventListener('resize', onResize, false)
      global.removeEventListener('orientationchange', onResize, false)
    }
  }, [])

  return breakpoints
}

export default useBreakpoints
